import React, { useEffect, useState } from "react";
import { Flipped, Flipper } from "react-flip-toolkit";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import Login from "./LogIn";
import Signup from "./SignUp";
import SignupInfo from "./components/SignupInfo";
import LoginInfo from "./components/LoginInfo";
import { MAVENCERY_STORES_NAMES } from "constants";

const Auth = () => {
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get("type");
  const [isSwapped, setIsSwapped] = useState(false);

  const handleClick = () => {
    setIsSwapped(!isSwapped);
    if (type === "login") {
      setSearchParams({ type: "signup" });
    } else if (type === "signup") {
      setSearchParams({ type: "login" });
    }
  };

  useEffect(() => {
    if (type === "login") {
      setIsSwapped(true);
    } else if (type === "signup") {
      setIsSwapped(false);
    }
  }, [setSearchParams, type]);
  return (
    <div className="flex items-center justify-center h-screen min-h-screen">
      <div
        className={`login-container flex w-full mx-0 bg-white md:mx-36 extraMedium:mx-12 extraMedium:h-2/4 px-0 lg:mx-36 h-4/5  ${
          !selectedStore?.isWhiteLabel
            ? "lg:bg-lightBlueColor "
            : selectedStore?.isWhiteLabel &&
              selectedStore.name === MAVENCERY_STORES_NAMES.AlHalalMeats
            ? "lg:bg-lightOrangeColor "
            : "lg:bg-lightBlueColor "
        }`}
      >
        <div className="flex items-center justify-center w-[100%]  ">
          <Flipper
            className="w-full"
            flipKey={isSwapped}
            spring={{ stiffness: 100, damping: 25 }}
          >
            <div className="flex items-center justify-center w-full px-8 bg-purple-600 cursor-pointer md:px-8 l8g:px-20 parent h-96 min-h-96">
              <Flipped flipId="div1">
                <div
                  className={`md:w-full lg:w-2/4 w-full h-[450px] rounded-md  md:flex lg:flex items-center justify-center  bg-white   z-10 ${
                    isSwapped ? "order-2" : "order-1"
                  } `}
                >
                  {isSwapped ? (
                    <Login isSwapped={isSwapped} setIsSwapped={setIsSwapped} />
                  ) : (
                    <Signup isSwapped={isSwapped} setIsSwapped={setIsSwapped} />
                  )}
                </div>
              </Flipped>
              <Flipped flipId="div2   ">
                <div
                  className={`w-2/4  hidden lg:flex extraMedium:h-full extraMedium:items-start   md:hidden items-center justify-center font-bold px-8   text-gray-800  ${
                    isSwapped ? "order-1" : "order-2"
                  } `}
                >
                  {isSwapped ? (
                    <SignupInfo onClick={handleClick} />
                  ) : (
                    <LoginInfo onClick={handleClick} />
                  )}
                </div>
              </Flipped>
            </div>
          </Flipper>
        </div>
      </div>
    </div>
  );
};

export default Auth;
